import {cookie} from "../lib/cookie";
import {writable} from 'svelte/store';
import {USER_ROLE} from "../lib/constants";

let userObject = {
    id: null,
    role_id: 0,
    name: null,
    email: null,
    token: null,
};

const {get, set, update, subscribe} = writable(userObject);

const user = {
    set,
    update,
    subscribe,

    getToken: () => {
        return userObject.token || '';
    },

    acronym : () => {
        if (!userObject.name) {
            return '';
        }
        return userObject.name.split(' ').map(function(item){return item[0]}).join('');
    },

    initialize: () => {
        user.update(obj => {
            obj.token = cookie.get('enorme-app') || null;
            return obj;
        });
    },

    setUser: data => {
        user.update(obj => {
            obj.id = data.id;
            obj.role_id = data.role_id;
            obj.name = data.name;
            obj.email = data.email;
            obj.token = data.token;
            user.saveCookie();
            return obj;
        });
    },

    clearToken: () => {
        user.update(obj => {
            obj.token = null;
            user.saveCookie();
            return obj;
        });
    },

    saveCookie: () => {
        if (userObject.token) {
            cookie.create('enorme-app', userObject.token);
        } else {
            cookie.delete('enorme-app');
        }
    },

    deleteCookie: () => {
        cookie.delete('enorme-app');
    },


    // saveCookie: () => {
    //     let coo = {
    //         token: userObject.token,
    //     };
    //     cookie.create('enorme-app', userObject.token);
    // },

    isAdmin: () => {
        return userObject.role_id == USER_ROLE.ADMIN;
    },

    allowCheckins: () => {
        return userObject.role_id == USER_ROLE.ADMIN || userObject.role_id == USER_ROLE.RECEPTIONIST;
    },
}

export default user;